module.exports = __webpack_public_path__ + "static/media/wishlist_banner.b5934646.jpg";